import { createSlice } from "@reduxjs/toolkit";

const emptyState = {
  access: "",
  username: "",
  name: "",
  isAuth: false,
  is_superuser: false,
  role: "",
  permissions: [],
  can_view_all_cash: false,
  cash_ledgers: [],
};

const initialState = localStorage.getItem("user")
  ? { ...emptyState, ...JSON.parse(localStorage.getItem("user")) }
  : emptyState;

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.access = action.payload.access;
      state.username = action.payload.username;
      state.name = action.payload.name || action.payload.username;
      state.isAuth = action.payload.isAuth;
      state.is_superuser = action.payload.is_superuser || false;
      state.role = action.payload.role || "";
      state.permissions = action.payload.permissions || [];
      state.can_view_all_cash = action.payload.can_view_all_cash || false;
      state.cash_ledgers = action.payload.cash_ledgers || [];
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    // Refreshes role/permissions without touching the token, so a change an
    // admin makes takes effect without forcing the user to sign in again.
    accessUpdated: (state, action) => {
      state.role = action.payload.role_name || "";
      state.permissions = action.payload.permissions || [];
      state.can_view_all_cash = action.payload.can_view_all_cash || false;
      state.cash_ledgers = action.payload.cash_ledgers || [];
      const stored = localStorage.getItem("user");
      if (stored) {
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...JSON.parse(stored),
            role: state.role,
            permissions: state.permissions,
            can_view_all_cash: state.can_view_all_cash,
            cash_ledgers: state.cash_ledgers,
          })
        );
      }
    },
    logoutSuccess: (state, action) => {
      state.access = null;
      state.username = null;
      state.name = "";
      state.isAuth = false;
      state.is_superuser = false;
      state.role = "";
      state.permissions = [];
      state.can_view_all_cash = false;
      state.cash_ledgers = [];

      localStorage.removeItem("user");
    },
  },
});

export const { loginSuccess, accessUpdated, logoutSuccess } = userSlice.actions;

export const selectUserName = (state) => state.user.name;
export const accessToken = (state) => state.user.access;
export const selectAuthenticated = (state) => state.user.isAuth;
export const selectPermissions = (state) => state.user.permissions || [];
export const selectRole = (state) => state.user.role;
export const selectIsSuperuser = (state) => state.user.is_superuser;

export default userSlice.reducer;
